<div #editor style='height: 100%'></div>
